import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './Landing Page/Home';
import Dashboard from './Dashboard/Dashboard';
import History from './Dashboard/History';
import AIResumeBuilder from './Dashboard/AIResumeBuilder';
import JobTailoredResume from './Dashboard/JobTailoredResume';
import QuestionContent from './Dashboard/questionDisplay/QuestionContent';
import HRQuestionsContent from './Dashboard/questionDisplay/HRQuestionsContent';
import PersonalizedAnswer from './Dashboard/personalizedAnswer/PersonalizedAnswer';
import AnswersPage from './Dashboard/questionDisplay/AnswersPage';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentCancel from './components/PaymentCancel';
import PaymentLoading from './components/PaymentLoading';
import SubscriptionGuard from './components/SubscriptionGuard';
import { AuthProvider } from './AuthContext';
import { SubscriptionProvider } from './SubscriptionContext';
import PrivateRoute from './PrivateRoute';
import About from './Landing Page/about';
import PrivacyPolicy from './Landing Page/Privacy Policy';
import TermsOfService from './Landing Page/Termsofservice';

function App() {
  return (
    <Router>
      <AuthProvider>
        <SubscriptionProvider>
          <div className="App">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              
              {/* Redirect routes for shorter URLs */}
              <Route path="/privacy" element={<Navigate to="/privacy-policy" replace />} />
              <Route path="/terms" element={<Navigate to="/terms-of-service" replace />} />
              
              {/* Payment routes */}
              <Route path="/payment-loading" element={<PaymentLoading />} />
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/payment-cancel" element={<PaymentCancel />} />
              
              {/* Protected dashboard routes - require subscription */}
              <Route 
                path="/dashboard" 
                element={
                  <PrivateRoute>
                    <SubscriptionGuard>
                      <Dashboard />
                    </SubscriptionGuard>
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/questions" 
                element={
                  <PrivateRoute>
                    <SubscriptionGuard>
                      <QuestionContent />
                    </SubscriptionGuard>
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/hr-questions" 
                element={
                  <PrivateRoute>
                    <SubscriptionGuard>
                      <HRQuestionsContent />
                    </SubscriptionGuard>
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/answers" 
                element={
                  <PrivateRoute>
                    <SubscriptionGuard>
                      <AnswersPage />
                    </SubscriptionGuard>
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/personalized-answer" 
                element={
                  <PrivateRoute>
                    <SubscriptionGuard>
                      <PersonalizedAnswer />
                    </SubscriptionGuard>
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/dashboard/history" 
                element={
                  <PrivateRoute>
                    <SubscriptionGuard>
                      <History />
                    </SubscriptionGuard>
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/dashboard/ai-resume-builder" 
                element={
                  <PrivateRoute>
                    <SubscriptionGuard>
                      <AIResumeBuilder />
                    </SubscriptionGuard>
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/dashboard/job-tailored-resume" 
                element={
                  <PrivateRoute>
                    <SubscriptionGuard>
                      <JobTailoredResume />
                    </SubscriptionGuard>
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/dashboard/question-content" 
                element={
                  <PrivateRoute>
                    <SubscriptionGuard>
                      <QuestionContent />
                    </SubscriptionGuard>
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/dashboard/personalized-answer" 
                element={
                  <PrivateRoute>
                    <SubscriptionGuard>
                      <PersonalizedAnswer />
                    </SubscriptionGuard>
                  </PrivateRoute>
                } 
              />
              <Route 
                path="/dashboard/answers-page" 
                element={
                  <PrivateRoute>
                    <SubscriptionGuard>
                      <AnswersPage />
                    </SubscriptionGuard>
                  </PrivateRoute>
                } 
              />
            </Routes>
          </div>
        </SubscriptionProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;